// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dash-image-model-btn {
    position: absolute;
    z-index: 9;
    bottom:  5px;
    right:  5px;
    background: rgba(0,0,0,0.05);
    border:  0;
    width:  40px;
    height:  40px;
    border-radius: 50%;
    box-sizing: border-box;
    transition:  transform .3s;
    font-size: 0;
    opacity: 1;
    pointer-events: auto;
    cursor:  pointer;
  }
  .dash-image-model-btn:hover {
    transform: scale(1.125);
  }
  .dash-image-model-btn span {
    background: white;
    width:  4px;
    height:  4px;
    border-top:  2.5px solid #111; /* color */
    border-left:  2.5px solid #111; /* color */
    position: absolute;
    outline: 1px solid transparent;
    -webkit-backface-visibility: hidden;
    transform: translateZ(0);
    will-change: transform;
    -webkit-perspective: 1000;
    transition:  .3s;
    transition-delay: .75s;
  }
  .dash-image-model-btn span:nth-child(1) {
    top: 11px;
    left: 11px;
  }
  .dash-image-model-btn span:nth-child(2) {
    top: 11px;
    left: 22px;
    transform: rotate(90deg);
  }
  .dash-image-model-btn span:nth-child(3) {
    top: 22px;
    left: 11px;
    transform: rotate(-90deg);
  }
  .dash-image-model-btn span:nth-child(4) {
    top: 22px;
    left: 22px;
    transform: rotate(-180deg);
  }
  
`, "",{"version":3,"sources":["webpack://./src/lib/components/style.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,6BAA6B,EAAE,UAAU;IACzC,8BAA8B,EAAE,UAAU;IAC1C,kBAAkB;IAClB,8BAA8B;IAC9B,mCAAmC;IACnC,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,UAAU;IACV,0BAA0B;EAC5B","sourcesContent":["\n.dash-image-model-btn {\n    position: absolute;\n    z-index: 9;\n    bottom:  5px;\n    right:  5px;\n    background: rgba(0,0,0,0.05);\n    border:  0;\n    width:  40px;\n    height:  40px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    transition:  transform .3s;\n    font-size: 0;\n    opacity: 1;\n    pointer-events: auto;\n    cursor:  pointer;\n  }\n  .dash-image-model-btn:hover {\n    transform: scale(1.125);\n  }\n  .dash-image-model-btn span {\n    background: white;\n    width:  4px;\n    height:  4px;\n    border-top:  2.5px solid #111; /* color */\n    border-left:  2.5px solid #111; /* color */\n    position: absolute;\n    outline: 1px solid transparent;\n    -webkit-backface-visibility: hidden;\n    transform: translateZ(0);\n    will-change: transform;\n    -webkit-perspective: 1000;\n    transition:  .3s;\n    transition-delay: .75s;\n  }\n  .dash-image-model-btn span:nth-child(1) {\n    top: 11px;\n    left: 11px;\n  }\n  .dash-image-model-btn span:nth-child(2) {\n    top: 11px;\n    left: 22px;\n    transform: rotate(90deg);\n  }\n  .dash-image-model-btn span:nth-child(3) {\n    top: 22px;\n    left: 11px;\n    transform: rotate(-90deg);\n  }\n  .dash-image-model-btn span:nth-child(4) {\n    top: 22px;\n    left: 22px;\n    transform: rotate(-180deg);\n  }\n  \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
